import { Component, Input, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef, OnInit } from '@angular/core';
import { Question } from '../../../../classes';
import { Subscription } from 'rxjs';
import { FormGroup, NgModel } from '@angular/forms';
import { questionTitleRequiredValidator } from './question-title-required-validator.fn';


@Component({
    selector: 'question-title',
    templateUrl: './question-title.component.html',
    styleUrls: ['./question-title.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
 
})
export class QuestionTitleComponent implements OnInit {
    @ViewChild('text') text:NgModel;
    @Input() question:Question;
    @Input() questionFormGroup:FormGroup;
    subscriptions:Subscription[] = [];
    constructor (
        private cdRef:ChangeDetectorRef,
    ) {}
    ngOnInit () {
        this.subscriptions.push(this.question.getChildTracker('text').onContentUpdate.subscribe(()=>this.refreshView()))
        this.addControls();
    }
    ngOnDestroy () {
        this.removeControls();
        this.subscriptions.forEach(sub=>sub.unsubscribe());
    }
    private addControls() {
        this.text.control.setValidators(questionTitleRequiredValidator(this.question));
        if (this.questionFormGroup) {
            this.questionFormGroup.setControl('text', this.text.control)
        }
    }
    private removeControls() {
        if (this.questionFormGroup) {
            this.questionFormGroup.removeControl('text');
        }
    }      
    private refreshView () {
        if (this.text) this.text.control.updateValueAndValidity()
        this.cdRef.detectChanges()
    } 
}
